
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        var mod = require("private-next-pages/_app.js");
        if (false && module.hot) {
          module.hot.accept("private-next-pages/_app.js", function () {
            if (!next.router.components["/_app"]) return;
            var updatedPage = require("private-next-pages/_app.js");
            next.router.update("/_app", updatedPage);
          });
        }
        return mod;
      }
    ]);
  